import { render } from "./IncidentView.vue?vue&type=template&id=607d9af1&scoped=true"
import script from "./IncidentView.vue?vue&type=script&lang=js"
export * from "./IncidentView.vue?vue&type=script&lang=js"

import "./IncidentView.vue?vue&type=style&index=0&id=607d9af1&scoped=true&lang=css"

import exportComponent from "/home/runner/work/GPSviaAIS/GPSviaAIS/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-607d9af1"]])

export default __exports__